import * as angular from "angular";
import type { ControlState } from "./control-state";
import confirmClear from "../../../behaviors/confirm-clear";
import template from "./null-control.html";

export interface NullControlController {
	control: ControlState;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class NullControlController implements angular.IController {
	public setNull(): void {
		this.control.change(null);
	}

	public clear(): void {
		this.control.change(undefined);
	}
}

export default angular.module("vesl.extensions.json-schema.null-control", [confirmClear])
	.component("jsonSchemaNullControl", {
		template,
		controller: NullControlController,
		bindings: { control: "<" }
	})
	.name;
